var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListStyleImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91561 3.78047L0.489905 0.0904667C0.377666 -0.0303609 0.195949 -0.0301578 0.0838976 0.0910917C-0.0280667 0.212326 -0.0277773 0.408716 0.0844763 0.529637L3.30627 4.00001L0.0843605 7.47038C-0.0278786 7.59131 -0.028168 7.78758 0.0837818 7.90883C0.139952 7.96961 0.213539 8 0.287126 8C0.360525 8 0.433822 7.96981 0.489891 7.90945L3.91561 4.21954C3.96967 4.16145 4 4.08239 4 4.00001C4 3.91764 3.96958 3.83867 3.91561 3.78047Z",
    fill: "#FF6B08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListStyleImage);
export default __webpack_public_path__ + "static/media/list-style-image.3158c564816e324e859d08b2c56f5594.svg";
export { ForwardRef as ReactComponent };